import React from 'react';

import './Docs.css';

import {ReactComponent as DocumentIcon} from "../../images/icons/document.svg";
import {ReactComponent as DownloadIcon} from "../../images/icons/download.svg";
import API from "../../components/api";
import {SERVER_URL} from "../../config";
import Utils from "../../utils";

import Image1 from '../../images/license/img.png';
import Image2 from '../../images/license/img_1.png';
import Image3 from '../../images/license/img_2.png';
import Image4 from '../../images/license/img_3.png';
import Image5 from '../../images/license/img_4.png';
import Image6 from '../../images/license/img_5.png';

class DocsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            docs: [], cards: [Image1, Image2, Image3, Image4, Image5, Image6], empDocs: []
        }
    }

    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search);
        const ref = queryParams.get('ref');
        if (ref === 'main') {
            setTimeout(() => {
                const scrollHeight = Math.max(
                    document.body.scrollHeight,
                    document.documentElement.scrollHeight,
                    document.body.offsetHeight,
                    document.documentElement.offsetHeight
                );

                window.scrollTo({
                    top: scrollHeight,
                    behavior: "smooth"
                });
            }, 100)
        }

        Utils.setPageTitle('Документы')

        API.getDocsPage()
            .then(data => this.setState({docs: data}))
            .catch(() => {
            })

        API.getEmpDocsPage()
            .then(data => this.setState({empDocs: data}))
            .catch(() => {
            })

    }

    render() {
        return <div className='docs'>
            <div className='page'>
                <div className='block'>
                    <div className='title'>Общие документы</div>
                    <div className='docs-list'>
                        {this.state.docs.map(item => {
                            return <div className='document'>
                                <div className='icon'>
                                    <DocumentIcon/>
                                </div>
                                <div className='content'>
                                    <div className='name'>
                                        {item.name}
                                    </div>
                                    <div className='weight'>
                                        {item.size}
                                    </div>
                                </div>
                                <a className='button download' href={SERVER_URL + item.document_url}
                                   target='_blank'>
                                    <DownloadIcon/>
                                </a>
                            </div>
                        })}
                    </div>
                </div>
                <div className='block'>
                    <div className='title'>Лицензия и свидетельства</div>
                    <div className='docs-list'>
                        {this.state.cards.map(item => {
                            return <div className='card'>
                                <img src={item} alt=''/>
                            </div>
                        })}
                    </div>
                </div>
                <div className='block'>
                    <div className='title'>Документы врачей</div>
                    <div className='docs-list'>
                        {this.state.empDocs.map(item => {
                            return <div className='document'>
                                <div className='icon'>
                                    <DocumentIcon/>
                                </div>
                                <div className='content'>
                                    <div className='name'>
                                        {item.name}
                                    </div>
                                    <div className='weight'>
                                        {item.size}
                                    </div>
                                </div>
                                <a className='button download' href={SERVER_URL + item.document_url}
                                   target='_blank'>
                                    <DownloadIcon/>
                                </a>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    }
}


export default DocsPage;
